import { type Translation } from "./en";

export const fa: Translation = {
  ai_speech_preview_free_title: "صدای استاندارد",
  ai_speech_preview_free_desc: "صدای رباتیک رایگان",
  ai_speech_preview_pro_desc: "صدای با کیفیت بالا با لحن طبیعی",
  ai_speech_preview_free_lbl: "رایگان",
  ai_speech_lang_support: "پشتیبانی از بیش از 30 زبان",
  ai_speech_listen: "شنیدن نمونه",
  voice_type_none: "هیچ",
  review_custom: "انتخاب موارد مرور",
  custom_new_cards: "کارت‌های جدید",
  custom_due_cards: "کارت‌های مرور",
  review_card_type: "نوع کارت را انتخاب کنید",
  settings_lang: "زبان",
  html_row: "سطر",
  html_column: "ستون",
  copied: "کپی شد",
  copy_code: "کپی کد",
  logout: "خروج",
  error_contact_support:
    "خطایی رخ داده است. لطفاً با پشتیبانی تماس بگیرید تا بتوانیم به شما کمک کنیم.",
  browser_no_personal_decks_start: "شما هنوز هیچ دسته کارت شخصی ندارید",
  browser_no_personal_decks_end: ". یادگیری خوبی داشته باشید! 😊",
  browser_no_personal_decks_link: "نحوه استفاده از MemoCard را در ",
  ai_card_input_mode_supports: "از زبان‌های مختلف پشتیبانی می‌کند",
  upgrade_pro: "ارتقا به نسخه حرفه‌ای",
  youtube_channel: "کانال یوتیوب",
  login_google: "ورود با گوگل",
  card_input_mode_changed: "حالت ورودی کارت تغییر کرد",
  card_input_mode_manual: "ورود دستی",
  card_input_mode_type: "اگر تایپ کنید",
  card_input_mode_get: "کارتی مانند این دریافت خواهید کرد",
  card_input_mode_screen: "حالت ورود کارت",
  generate: "ایجاد",
  folder_form_no_decks: "هیچ دسته کارتی در پوشه نیست",
  cards_add: "افزودن کارت‌ها",
  card_next: "بعدی",
  card_previous: "قبلی",
  user_stats_empty_text: "برای مشاهده داده‌ها، کارت‌های بیشتری مطالعه کنید",
  read_more: "بیشتر بخوانید",
  hide_card_forever: "پنهان کردن برای همیشه",
  mute_cards: "بی‌صدا کردن",
  unmute_cards: "فعال کردن صدا",
  hide_card_forever_confirm_title:
    "آیا مطمئن هستید که می‌خواهید این کارت را برای همیشه پنهان کنید؟ دیگر آن را نخواهید دید",
  wysiwyg_big_header: "سرتیتر بزرگ",
  next: "بعدی",
  review_again: "دوباره",
  review_hard: "سخت",
  review_good: "خوب",
  review_easy: "آسان",
  wysiwyg_text_color: "رنگ متن",
  wysiwyg_bold: "ضخیم",
  wysiwyg_italic: "مورب",
  wysiwyg_undo: "برگشت",
  wysiwyg_clear_formatting: "پاک کردن قالب‌بندی",
  my_decks: "دسته کارت‌های من",
  formatting: "قالب‌بندی",
  deck: "دسته کارت",
  deck_description: "مجموعه‌ای از کارت‌ها",
  folder: "پوشه",
  folder_description: "مجموعه‌ای از دسته کارت‌ها",
  decks: "دسته کارت‌ها",
  edit_folder: "ویرایش پوشه",
  add_folder: "افزودن پوشه",
  add_deck_to_folder: "افزودن دسته کارت به پوشه",
  decks_in_other_folders: "دسته کارت‌ها در پوشه‌های دیگر",
  no_decks_to_add: "دسته کارت دیگری برای افزودن وجود ندارد",
  show_all_decks: "نمایش همه",
  hide_all_decks: "پنهان کردن",
  select_all: "انتخاب همه",
  deselect_all: "لغو انتخاب",
  select: "انتخاب",
  selected: "انتخاب شده",
  add_deck: "افزودن دسته کارت",
  add: "افزودن",
  edit_deck: "ویرایش دسته کارت",
  edit: "ویرایش",
  view: "مشاهده",
  all_decks_reviewed:
    "کار عالی! 🌟 شما همه دسته کارت‌ها را مرور کرده‌اید. بعداً برای موارد بیشتر برگردید.",
  public_decks: "دسته کارت‌های عمومی",
  explore_public_decks: "کاوش دسته کارت‌های بیشتر",
  news_and_updates: "اخبار و به‌روزرسانی‌ها",
  profile_section: "نمایه",
  telegram_channel: "کانال تلگرام",
  settings: "تنظیمات",
  deck_has_been_added: "این دسته کارت در لیست شما است",
  deck_catalog: "فهرست دسته کارت‌ها",
  translated_to: "ترجمه شده به",
  any_language: "هر زبانی",
  category: "دسته‌بندی",
  any_category: "هر دسته‌ای",
  deck_search_not_found: "هیچ دسته کارتی پیدا نشد",
  card_search_not_found: "هیچ کارتی پیدا نشد",
  deck_search_not_found_description:
    "فیلترها را به‌روز کنید تا موارد بیشتری ببینید",
  category_English: "انگلیسی",
  category_Thai: "تایلندی",
  category_Geography: "جغرافیا",
  category_History: "تاریخ",
  category_Chemistry: "شیمی",
  category_Spanish: "اسپانیایی",
  category_Other: "سایر",
  save: "ذخیره",
  add_card: "افزودن کارت",
  edit_card: "ویرایش کارت",
  card_preview: "پیش‌نمایش",
  add_card_short: "افزودن کارت",
  add_deck_short: "دسته کارت",
  card_front_title: "روی کارت",
  card_back_title: "پشت کارت",
  card_front_side_hint: "سؤال یا راهنما",
  card_back_side_hint: "پاسخی که باید ارائه دهید",
  card_field_example_title: "مثال",
  card_field_example_hint: "اطلاعات اضافی (اختیاری)",
  cards: "کارت‌ها",
  search_card: "جستجوی کارت",
  card_sort_by_date: "تاریخ",
  card_sort_by_front: "رو",
  card_sort_by_back: "پشت",
  sort_by: "مرتب‌سازی بر اساس",
  title: "عنوان",
  description: "توضیحات",
  speaking_cards: "کارت‌های گفتاری",
  voice_language: "زبان صدا",
  card_speak_side: "طرف کارت",
  front: "رو",
  back: "پشت",
  card_speak_description: "پخش صدای گفتاری برای هر کارت برای شنیدن تلفظ",
  review_deck_finished: "شما این دسته کارت را تمام کردید 🎉",
  review_all_cards: "شما همه کارت‌ها را برای امروز تکرار کردید 🎉",
  review_finished_want_more: "بیشتر می‌خواهید؟ شما دارید",
  review_finished_to_review: "برای مطالعه",
  review_deck: "مرور دسته کارت",
  review_folder: "مرور پوشه",
  cards_to_repeat: "برای تکرار",
  cards_new: "کارت‌های جدید",
  cards_total: "کل کارت‌ها",
  duplicate: "کپی",
  duplicate_deck_confirm:
    "آیا مطمئن هستید که می‌خواهید این دسته کارت را کپی کنید؟",
  duplicate_folder_confirm:
    "آیا مطمئن هستید که می‌خواهید این پوشه را کپی کنید؟",
  delete_deck_confirm_shared: "حذف دسته کارت از مجموعه شما؟",
  delete_folder_confirm_shared: "حذف پوشه از مجموعه شما؟",
  delete_deck_confirm_author:
    "حذف دسته کارت از MemoCard؟ این عمل قابل برگشت نیست",
  delete_folder_confirm_author: "حذف پوشه از MemoCard؟ این عمل قابل برگشت نیست",
  deck_form_remove_card_confirm:
    "آیا مطمئن هستید که می‌خواهید کارت را حذف کنید؟ تمام بررسی‌های کارت از تمام کاربران از دست خواهد رفت",
  deck_form_remove_cards_confirm:
    "آیا مطمئن هستید که می‌خواهید همه کارت‌های انتخاب شده را حذف کنید؟",
  delete: "حذف",
  no_cards_to_review_in_deck:
    "کار عالی! 🌟 شما همه کارت‌ها را در این دسته کارت مرور کرده‌اید. بعداً برای موارد بیشتر برگردید.",
  repeat_cards_anyway: "به هر حال تکرار کن",
  no_cards_to_review_all:
    "کار عالی! 🌟 شما همه کارت‌ها را برای امروز تکرار کرده‌اید. بعداً برای موارد بیشتر برگردید.",
  review_show_answer: "نمایش پاسخ",
  share: "اشتراک‌گذاری",
  warning_telegram_outdated_title: "تلگرام شما قدیمی است",
  warning_telegram_outdated_description:
    "لطفاً تلگرام خود را به‌روز کنید تا از عملکرد پایدار این برنامه اطمینان حاصل شود.",
  settings_review_notifications: "اعلان‌های مرور",
  settings_time: "زمان",
  settings_review_notifications_hint:
    "یادآوری‌های روزانه به شما کمک می‌کند تا کارت‌ها را تکرار کنید",
  validation_deck_title: "عنوان دسته کارت الزامی است",
  deck_form_quit_card_confirm: "خروج از ویرایش کارت بدون ذخیره؟",
  quit_without_saving: "خروج بدون ذخیره؟",
  folder_form_quit_card_confirm: "خروج از ویرایش پوشه بدون ذخیره؟",
  deck_form_quit_deck_confirm: "خروج از ویرایش دسته کارت بدون ذخیره؟",
  deck_category: "دسته‌بندی دسته کارت",
  validation_required: "این فیلد الزامی است",
  share_link_copied: "لینک در کلیپ‌بورد کپی شد",
  settings_contact_support: "تماس با پشتیبانی در تلگرام",
  settings_support_hint: "اگر مشکل، سؤال یا پیشنهادی دارید",
  payment_description: "دسترسی به امکانات بیشتر",
  payment_choose_duration: "مدت",
  payment_choose_subscription: "اشتراک",
  payment_choose_method: "روش پرداخت",
  payment_method_usd: "کارت بانکی",
  payment_method_stars: "ستاره‌های تلگرام",
  payment_included: "چه چیزی شامل می‌شود",
  payment_paid_until: "پرداخت شده تا",
  ai_cards_left: "کارت‌های هوش مصنوعی باقیمانده این ماه",
  payment_tos_and_pp_agree: "با خرید MemoCard، شما موافقت می‌کنید با",
  payment_tos: "شرایط خدمات",
  payment_and: " و ",
  payment_pp: "سیاست حریم خصوصی",
  privacy_policy: "سیاست حریم خصوصی",
  go_back: "بازگشت",
  validation_at_least_one_deck: "لطفاً حداقل ۱ دسته کارت انتخاب کنید",
  add_answer: "افزودن پاسخ آزمون",
  answer_text: "متن پاسخ",
  review_correct_label: "درست",
  review_wrong_label: "نادرست",
  advanced: "پیشرفته",
  review_idk: "نمی‌دانم",
  card_answer_type: "نوع کارت",
  yes_no: "به یاد آوردن",
  yes: "بله",
  answer_type_choice: "آزمون",
  answer_type_explanation_remember:
    'کارتی با دکمه‌های "به یاد دارم" و "به یاد ندارم"',
  answer_type_explanation_choice: "کارتی با گزینه‌های پاسخ",
  validation_answer_at_least_one_correct:
    "یک پاسخ باید به عنوان درست انتخاب شود",
  validation_at_least_one_answer_required: "حداقل یک پاسخ باید ارائه شود",
  user_stats_btn: "آمار",
  user_stats_page: "آمار من",
  user_stats_remembered: "به یاد آورده شده",
  user_stats_remembered_hint:
    "تعداد کارت‌هایی که ۵ بار پشت سر هم درست مرور شده‌اند",
  user_stats_learning: "در حال یادگیری",
  user_stats_learning_hint:
    "تعداد کارت‌هایی که کمتر از ۵ بار پشت سر هم مرور شده‌اند",
  user_stats_total: "کل کارت‌ها",
  user_stats_total_hint: "تعداد کل کارت‌هایی که حداقل یک بار باز شده‌اند",
  user_stats_learning_time: "توزیع زمان یادگیری",
  user_stats_learning_time_hint:
    "چگونه زمان شما بین یادگیری مطالب جدید و مرور تقسیم می‌شود",
  user_stats_chart_min_expl: "کارت را نمی‌دانم",
  user_stats_chart_max_expl: "کارت را خیلی خوب می‌دانم",
  validate_positive: "لطفاً یک عدد مثبت وارد کنید",
  validate_under_100: "لطفاً عددی کمتر از ۱۰۰ وارد کنید",
  freeze_confirm_freeze:
    "آیا مطمئن هستید که می‌خواهید کارت‌های خود را منجمد کنید؟ این عمل قابل برگشت نیست.",
  freeze_title: "انجماد کارت‌ها",
  how: "چگونه کار می‌کند",
  freeze_rule_1:
    "همه کارت‌های شما متوقف می‌شوند و هیچ اعلانی دریافت نخواهید کرد.",
  freeze_rule_2:
    "تعداد کارت‌های مرور در طول دوره انجماد افزایش نمی‌یابد؛ هنگام از سرگیری، همان تعداد کارت را خواهید دید.",
  freeze_rule_3: "انجماد کارت‌ها قابل برگشت نیست.",
  freeze_rule_4:
    "اگر در طول دوره انجماد کارتی اضافه کنید، تحت تأثیر انجماد قرار نمی‌گیرد.",
  freeze_for: "انجماد برای",
  freeze_for_or_manual: "یا به صورت دستی وارد کنید",
  freeze_notified: "به شما اطلاع داده خواهد شد در",
  freeze_hint: "به تعویق انداختن مطالعه کارت‌ها",
  ui_loading: "در حال بارگذاری...",
  is_on: "روشن",
  is_off: "خاموش",
  error_solving: "ما در حال حل مشکل هستیم",
  error: "خطا",
  user_settings_updated: "تنظیمات به‌روز شد",
  ai_speech_validate: "لطفاً یک طرف را انتخاب کنید یا متن را وارد کنید",
  ai_speech_type: "یا متن مورد نیاز را تایپ کنید",
  ai_speech_empty:
    "هیچ صدای هوش مصنوعی تولید نشده است. طرف کارت را در زیر انتخاب کنید.",
  ai_speech_title: "گفتار هوش مصنوعی",
  ai_speech_generate: "تولید",
  ai_cards_generate: "تولید کارت‌ها",
  ai_cards_title: "تولید کارت با هوش مصنوعی",
  ai_cards_previous_prompts: "تاریخچه دستورات",
  ai_cards_no_previous_prompts: "هیچ دستور قبلی وجود ندارد",
  ai_cards_prompt: "توضیحات",
  ai_cards_prompt_front: "توضیحات روی کارت",
  ai_cards_prompt_back: "توضیحات پشت کارت",
  ai_cards_by_ai: "کارت‌های تولید شده توسط هوش مصنوعی",
  ai_cards_confirm_delete: "آیا مطمئن هستید که می‌خواهید این کارت را حذف کنید؟",
  ai_cards_added: "کارت‌ها اضافه شدند",
  ai_cards_use_template: "استفاده از قالب",
  payment_success: "پرداخت موفقیت‌آمیز بود. از امکانات اضافی لذت ببرید 😊",
  confirm_cancel: "لغو",
  confirm_ok: "تأیید",
  payment_failed:
    "پرداخت ناموفق بود. ما از این مشکل آگاه هستیم و در حال کار روی آن هستیم. لطفاً از طریق تنظیمات > پشتیبانی با پشتیبانی تماس بگیرید.",

  // Global Search
  global_search_placeholder: "جستجوی دسته‌ها، پوشه‌ها، کارت‌ها",
  global_search_no_results: "نتیجه‌ای یافت نشد",
  global_search_cancel: "لغو",
  global_search_start_typing:
    "برای جستجوی دسته‌ها، پوشه‌ها و کارت‌ها شروع به تایپ کنید",
  global_search_tabs_cards: "کارت‌ها",
  global_search_tabs_decks: "دسته‌ها",
  global_search_tabs_folders: "پوشه‌ها",
  global_search_context_folder: "پوشه",
  global_search_context_deck: "دسته",

  // About page
  about_title: "درباره",
  about_paragraph_1:
    "MemoCard رو ساختم چون اپ‌هایی مثل Anki اذیت‌کننده‌ان. قدرتمندن ولی باید ساعت‌ها تنظیمشون کنی، یادآوری ندارن و قدیمی به نظر میان.",
  about_paragraph_2:
    "تو مسابقه مینی اپ‌های تلگرام، اپ کارت‌هایی که همیشه می‌خواستم رو ساختم. نیازی به تنظیمات نداره، یادآوری‌ها خودکار کار می‌کنن و همه چیز ساده‌س.",
  about_paragraph_3:
    "از روش علمی تکرار فاصله‌دار ابینگهاوس استفاده می‌کنه. کارت‌ها دقیقاً موقعی ظاهر میشن که دارید فراموش می‌کنید - اینطوری بهترین حفظ می‌شه.",
  about_paragraph_4:
    "MemoCard تو مسابقه جایزه برد. حالا هزاران نفر در سراسر دنیا ازش استفاده می‌کنن.",
  about_visit_website: "بازدید از وب‌سایت ←",
  about_github_frontend: "مخزن GitHub فرانت‌اند ←",

  // Card Input Mode Form
  card_input_mode_form_title: "عنوان",
  card_input_mode_form_ai_prompt: "درخواست هوش مصنوعی",
  card_input_mode_form_create_title: "ایجاد حالت ورودی",
  card_input_mode_form_edit_title: "ویرایش حالت ورودی",
  card_input_mode_form_delete_confirm: "حذف این حالت ورودی؟",
  card_input_mode_add_button: "افزودن حالت ورودی",
  card_input_mode_form_title_placeholder: "مثلاً: تعریفات انگلیسی",
  card_input_mode_form_prompt_placeholder:
    "مثلاً: یک کارت تعریف برای کلمه‌ی :template_word بساز",
  card_input_mode_form_front_placeholder: "مثلاً: کلمه یا اصطلاح",
  card_input_mode_form_back_placeholder: "مثلاً: تعریف ساده",
  card_input_mode_form_example_placeholder: "مثلاً: مثال استفاده یا زمینه",
  card_input_mode_form_save_success: "حالت ورودی ذخیره شد",
  card_input_mode_form_delete_success: "حالت ورودی حذف شد",
  quit_card: "خروج از کارت",

  // Wysiwyg Help
  wysiwyg_help_title: "راهنمای قالب‌بندی متن",
  wysiwyg_help_step1: "متنی که می‌خواهید تغییر دهید را انتخاب کنید",
  wysiwyg_help_step2: "هر دکمه‌ای از نوار ابزار را فشار دهید",
  wysiwyg_help_bold: "متن پررنگ",
  wysiwyg_help_italic: "متن کج",
  wysiwyg_help_color: "تغییر رنگ متن",
  wysiwyg_help_heading: "بزرگ کردن متن (سرتیتر)",
  wysiwyg_help_table: "درج جدول",
  wysiwyg_help_clear: "حذف همه قالب‌بندی‌ها",
  wysiwyg_help_undo: "برگردان آخرین عمل",

  reverse_cards: "کارت‌های معکوس",
  reverse_cards_title: "کارت‌های معکوس",
  reverse_cards_helper: "یکی بساز، دو تا بگیر. به یادآوری بهتر کمک می‌کند",
  two_cards_created: "۲ کارت ایجاد شد",
  card_created: "کارت ایجاد شد",

  // Move card to deck
  move_card_to_deck_title: "انتقال به دسته",
  move_card_without_folder: "بدون پوشه",
  move_card_move: "انتقال",
  move_card_open_deck: "باز کردن دسته",

  // Image related
  image: "تصویر",

  // Skip card
  skip_card_for_now: "رد شدن فعلاً",
  skip_card_confirm: "از این کارت رد شوید؟ تا مرور بعدی پنهان می‌شود",
  review_skipped: "رد شده",
};
